// extracted by mini-css-extract-plugin
module.exports = {"menu-header":"qkGvFcQJ","submenu-header":"tHxn7Z4T","section-title":"SyF9EFV5","exact":"L5ApsWZ5","disabled":"iZIOthiW"};